import { GenderType } from "../../common/type/gender-type";

export class RequestContext {
  accountEmail: string;
  accountName: string;
  accountId: string;
  companyCode: string;
  companyId: string;
  companyName: string;
  userId: string;
  userEmail: string;
  userName: string;
  jobTitle: string;
  authCode: string;
  authPassword: string;
  phoneNumber: string;
  gender: GenderType;
  birthDate: Date; //출생년도 (나이계산)
  joinDate: Date; // 입사일
  ips: string[];
  ticketId: string;

  constructor(obj?: any) {
    const model = obj || {};
    Object.assign(this, model);

    this.birthDate = model.birthDate ? new Date(model.birthDate) : null;
    this.joinDate = model.joinDate ? new Date(model.joinDate) : null;
  }
}
